/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import './Snackbar.css';
import CloseIcon from './baseline_clear_white_24dp.png';

/**
 * Represents the snackbar component.
 */

export default class Snackbar extends Component {
 
    /**
     * Default state.
     */

    state = {
        message:    '',
        error:      false
    }

    /**
     * Shows the snackbar with the message.
     * 
     * @param   {String}    message     message that has to show
     * @param   {Boolean}   error       is it an error message or not
     * @param   {Boolean}   short       is it a short message or not
     */

    show = (message, error, short) => {

        // Preparing

        this.setState({ message: message, error: error });
        this.snackbar.style.transform = 'translateY(0px)';

        // Canceling the hiding timer for the previous message

        if (this.timer) {
            clearTimeout(this.timer);
        }

        // Scheduling the hiding

        this.timer = setTimeout(() => {
            if (this.snackbar) {
                this.snackbar.style.transform = 'translateY(96px)';
            }
        }, short ? 3000 : 5000);
    }

    /**
     * Closes the scnackbar.
     */

    close = () => {

        // Canceling the hiding timer

        if (this.timer) {
            clearTimeout(this.timer);
        }

        // Hiding the snackbar

        if (this.snackbar) {
            this.snackbar.style.transform = 'translateY(96px)';
        }
    }

    /**
     * Snackbar renderer.
     */

    render() {
        return (
            <div ref={c => {this.snackbar = c;}} className={`snackbar ${this.state.error ? 'snackbar-error' : 'snackbar-normal'}`}>
                <div className="horizontal center">
                    <div className="snackbar-text">{this.state.message}</div>
                    <div><img alt="Close" src={CloseIcon} className="snackbar-icon" onClick={this.close} /></div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Snackbar/Snackbar.js